import React from 'react'

const LocalesInTitulo = props => (
  <section name="#locales-internacionales" id="locales-internacionales" className="section tanta-mundo-titulo"
    data-aos="fade-up" data-aos-duration="750" data-aos-offset="160" data-aos-easing="ease-in-out-quad">
    <div className="container">
      <div className="columns">
        <div className="column is-10 is-offset-1">
          <h2>{props.lang === "es" ? props.apiHome.titulo_locales_int : props.apiHome.titulo_locales_int}</h2>
        </div>
      </div>
    </div>
  </section>
);

export default LocalesInTitulo;
